import { useQuery } from '@tanstack/react-query';
import { surveyAuditApi } from '../api/surveyAuditApi';
import { surveyAuditQueryKeys } from './queryKeys';
import { UseAuditQuestionsOptions } from '../types';

// Hook for getting audit questions
export const useAuditQuestions = (auditId: string, options?: UseAuditQuestionsOptions) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.questions(auditId),
    queryFn: () => surveyAuditApi.getAuditQuestions(auditId),
    enabled: options?.enabled !== false && !!auditId,
    staleTime: 5 * 60 * 1000, // 5 minutes - questions don't change frequently
  });
};
